import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "toolbar"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "icon-undo-left" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-undo-right" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icon-bold" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "icon-italic" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "icon-strikethrough" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "icon-paragraph-left" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "icon-paragraph-center" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "icon-paragraph-right" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "icon-paragraph-justify" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_21 = { class: "text" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_scroll = _resolveComponent("ui-scroll")!

  return (_ctx.type === 'extended')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["ui-text-editor", { 'full-screen': _ctx.stretchDraft }]),
        onKeyup: _cache[15] || (_cache[15] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onPressCtrEnter && _ctx.onPressCtrEnter(...args)), ["ctrl"]), ["enter"])),
        tabindex: "1",
        onMouseover: _cache[16] || (_cache[16] = ($event: any) => (_ctx.hover = true)),
        onMouseout: _cache[17] || (_cache[17] = ($event: any) => (_ctx.hover = false))
      }, [
        (_ctx.isToolbar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.wysiwygFormat('undo')))
                }, _hoisted_3),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.wysiwygFormat('redo')))
                }, _hoisted_5),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.wysiwygFormat('bold')))
                }, _hoisted_7),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.wysiwygFormat('italic')))
                }, _hoisted_9),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.wysiwygFormat('strikeThrough')))
                }, _hoisted_11),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.wysiwygFormat('justifyLeft')))
                }, _hoisted_13),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.wysiwygFormat('justifyCenter')))
                }, _hoisted_15),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.wysiwygFormat('justifyRight')))
                }, _hoisted_17),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.wysiwygFormat('justifyFull')))
                }, _hoisted_19)
              ]),
              _hoisted_20
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          (_ctx.stretchDraft)
            ? (_openBlock(), _createBlock(_component_ui_scroll, {
                key: 0,
                style: {"height":"100vh"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    id: "editor",
                    style: _normalizeStyle({ minHeight: _ctx.minHeight }),
                    ref: "editor",
                    tabindex: "-1",
                    contenteditable: "",
                    onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args))),
                    onPaste: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args))),
                    innerHTML: _ctx.innerValue
                  }, null, 44, _hoisted_22),
                  (_ctx.modelValue.length == 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "placeholder",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.setActive && _ctx.setActive(...args))),
                        tabindex: "-1"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.placeholder), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", {
                  id: "editor",
                  style: _normalizeStyle({ minHeight: _ctx.minHeight }),
                  ref: "editor",
                  tabindex: "-1",
                  contenteditable: "",
                  onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args))),
                  onPaste: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args))),
                  innerHTML: _ctx.innerValue
                }, null, 44, _hoisted_24),
                (_ctx.modelValue.length == 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "placeholder",
                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.setActive && _ctx.setActive(...args))),
                      tabindex: "-1"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.placeholder), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ], 34))
    : _createCommentVNode("", true)
}